module.exports = __webpack_public_path__ + "static/img/01.699f1461.jpg";